export { default, links, meta } from "/jsonhero/app/routes/privacy.mdx";